import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { GetIftaLogsParams, IftaLogsByStateDto, IftaLogsDto } from '@fleet-beat/api';
import {
  AuthHeaders,
  BaseApiService,
  CoreInjectorTokens,
  Environment,
  PageableListV2Dto,
  ResponseDto,
} from '@fleet-beat/core';
import { Observable, catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IftaLogsApiService {
  private readonly baseUrl: string = `${this.environment.apiEndpoint}/companies`;

  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private baseApiService: BaseApiService,
  ) {}
  getMany(companyId: string, data: GetIftaLogsParams, auth: AuthHeaders): Observable<PageableListV2Dto<IftaLogsDto>> {
    return this.baseApiService.get(`${this.baseUrl}/${companyId}/ifta-logs`, { auth, params: data }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<IftaLogsDto[]>) => this.baseApiService.mapResponseV2(response)),
      map((response: ResponseDto<IftaLogsDto[]>) => {
        return {
          ...response,
          ...response.meta,
        };
      }),
    );
  }

  getManyByState(
    companyId: string,
    data: GetIftaLogsParams,
    auth: AuthHeaders,
  ): Observable<PageableListV2Dto<IftaLogsByStateDto>> {
    return this.baseApiService.get(`${this.baseUrl}/${companyId}/ifta-logs/by-states`, { auth, params: data }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<IftaLogsByStateDto[]>) => this.baseApiService.mapResponseV2(response)),
    );
  }

  getCSVReport(companyId: string, auth: AuthHeaders, params?: GetIftaLogsParams): Observable<Blob> {
    return this.baseApiService
      .get<Blob>(`${this.baseUrl}/${companyId}/ifta-logs/reports/csv`, { auth, params, responseType: 'blob' as 'json' })
      .pipe(
        catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
        map((response: Blob) => response),
      );
  }

  getPDFReport(
    companyId: string,
    auth: AuthHeaders,
    params?: GetIftaLogsParams,
  ): Observable<ResponseDto<{ url: string }>> {
    return this.baseApiService.get(`${this.baseUrl}/${companyId}/ifta-logs/reports/pdf`, { auth, params }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<{ url: string }>) => this.baseApiService.mapResponseV2(response)),
    );
  }
}
